import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type SessionState } from '../types';

const impersonateCase: CaseReducer<
  SessionState,
  PayloadAction<{ impersonationToken: string }>
> = (state, action) => {
  const { impersonationToken } = action.payload;
  state.credentials.impersonationToken = impersonationToken;
};

export { impersonateCase };
